// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
table {
  width: 100%;
  box-shadow: none;
}

header, footer {
  background-color: #90CAFC;
}

.page-title {
  font-size: large;
}

.content {
  height: 70vh;
  overflow: auto;
}

.mat-drawer-content {
  overflow: hidden !important;
}

::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {
  background: inherit;
}

.pull-down {
  padding-top: 20px;
}

.button {
  background-color: #90CAFC;
}

.sub-header {
  background-color: #CCE2F5;
}

.edit-mode {
  color: blue;
}

.loading {
  background-color: white;
}

.tenant-name-header {
  text-align: left;
  background-color: white;
  width: 22%;
}

.meter-name-header {
  text-align: left;
  background-color: white;
  width: 15%;
}

.partition-name-header {
  text-align: left;
  background-color: white;
  width: 10%;
}

.camera_btn {
  width: 25px !important;
  height: 25px !important;
  margin: 0 !important;
  padding: 0 !important;
  align-items: flex-end;
}

.cam_btn {
  width: 25px !important;
  height: 25px !important;
  vertical-align: middle !important;
}

.meter-number-header {
  text-align: center;
  background-color: white;
  width: 10%;
}

.meter-type-header {
  text-align: center;
  background-color: white;
  width: 7%;
}

.elec-pow-header {
  text-align: center;
  width: 12%;
  min-width: 160px;
}

.elec-pow-used-header {
  text-align: center;
  background-color: white;
  width: 12%;
  min-width: 160px;
}

.water-used-header {
  text-align: center;
  background-color: lightcyan;
}

.tenant-name {
  background-color: whitesmoke;
}

.meter-label {
  text-align: center;
  background-color: whitesmoke;
}

.meter-value {
  text-align: right;
  padding-right: 10px;
  padding-bottom: 7px;
}

.last-value {
  text-align: right;
  padding-right: 10px;
}

.elec-pow-value {
  text-align: right;
  background-color: cornsilk;
  padding-right: 10px;
}

.last-month-value {
  color: darkolivegreen;
}

.blank-used {
  background-color: none !important;
  text-align: right;
  padding-right: 10px;
}

.power-used {
  background-color: rgb(190, 240, 155) !important;
  text-align: right;
  padding-right: 10px;
}

.water-used {
  background-color: lightcyan !important;
  text-align: right;
  padding-right: 10px;
}

.gas-used {
  background-color: rgb(229, 227, 255) !important;
  text-align: right;
  padding-right: 10px;
}

.alert-value {
  color: red;
}

.alert-value-blue {
  color: blue;
}

.blank-value {
  color: rgb(173, 173, 173);
  padding-right: 10px;
}

.meter-report-component-all {
  display: flex;
  flex-flow: column;
}

.meter-report-component-main {
  flex: 1;
  height: 94vh;
}

.main-area {
  height: 100%;
  overflow-y: auto;
  background-color: white;
}

.menu-list {
  height: 100%;
}

.no-tenant {
  color: darkorange;
}

.footer {
  width: 100%;
  position: absolute; /*←絶対位置*/
  bottom: 0; /*下に固定*/
}

.mat-mdc-raised-button.mat-confirmed {
  color: green;
  background-color: white;
}

.mat-mdc-raised-button.mat-not-confirmed {
  color: darkorange;
  background-color: white;
}

.meter-name {
  background-color: whitesmoke;
}

.meter-type {
  background-color: whitesmoke;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/meter-report/meter-report.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,WAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBCPa;ADQjB;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,YAAA;EACA,cAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAGA;EACI,gBAAA;EACA,uBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,uBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,gBAAA;EACA,uBAAA;EACA,UAAA;AAAJ;;AAIA;EACI,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,uBAAA;EACA,iCAAA;AADJ;;AAKA;EACI,kBAAA;EACA,uBAAA;EACA,UAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,uBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,2BAAA;AAFJ;;AAKA;EACI,4BAAA;AAFJ;;AAKA;EACI,kBAAA;EACA,4BAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,0BAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,iCAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,+CAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,sCAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,+CAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA;EACI,WAAA;AAFJ;;AAKA;EACI,yBAAA;EACA,mBAAA;AAFJ;;AAMA;EACI,aAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,OAAA;EACA,YAAA;AAHJ;;AAMA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ;;AAMA;EACI,iBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,kBAAA,EAAA,QAAA;EACA,SAAA,EAAA,OAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,uBAAA;AAHJ;;AAMA;EACI,4BAAA;AAHJ;;AAMA;EACI,4BAAA;EACA,kBAAA;AAHJ","sourcesContent":["@import \"variables\";\ntable {\n    width: 100%;\n    box-shadow: none;\n}\n\nheader, footer{\n    background-color: $main-backgroud;\n}\n\n.page-title{\n    font-size: large\n}\n\n.content{\n    height: 70vh;\n    overflow: auto;\n}\n\n.mat-drawer-content{\n    overflow: hidden !important;\n}\n\n::ng-deep .mat-mdc-form-field-type-mat-select:not(.mat-form-field-disabled) .mat-mdc-text-field-wrapper {\n    background: inherit;\n}\n\n.pull-down {\n    padding-top: 20px\n}\n\n.button{\n    background-color: #90CAFC;\n}\n\n.sub-header{\n    background-color: #CCE2F5;\n}\n\n.edit-mode{\n    color: blue;\n}\n\n.loading{\n    background-color: white;\n}\n\n\n.tenant-name-header{\n    text-align: left;\n    background-color:white;\n    width: 22%\n}\n\n.meter-name-header{\n    text-align: left;\n    background-color:white;\n    width: 15%\n}\n\n.partition-name-header{\n    text-align: left;\n    background-color:white;\n    width: 10%\n}\n\n\n.camera_btn {\n    width: 25px !important;\n    height: 25px !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    align-items:flex-end;\n}\n\n.cam_btn {\n    width: 25px !important;\n    height: 25px !important;\n    vertical-align: middle !important;\n   // padding-top: 10px;\n}\n\n.meter-number-header{\n    text-align: center;\n    background-color:white;\n    width: 10%\n}\n\n.meter-type-header{\n    text-align: center;\n    background-color:white;\n    width: 7%\n}\n\n.elec-pow-header{\n    text-align: center;\n    width: 12%;\n    min-width: 160px;\n}\n\n.elec-pow-used-header{\n    text-align: center;\n    background-color:white;\n    width: 12%;\n    min-width: 160px;\n}\n\n.water-used-header{\n    text-align: center;\n    background-color:lightcyan;\n}\n\n.tenant-name{\n    background-color:whitesmoke;\n}\n\n.meter-label{\n    text-align: center;\n    background-color:whitesmoke;\n}\n\n.meter-value{\n    text-align: right;\n    padding-right: 10px;\n    padding-bottom: 7px;\n}\n\n.last-value{\n    text-align: right;\n    padding-right: 10px;\n}\n\n.elec-pow-value{\n    text-align: right;\n    background-color:cornsilk;\n    padding-right: 10px;\n}\n\n.last-month-value{\n    color: darkolivegreen\n}\n\n.blank-used{\n    background-color: none !important;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.power-used{\n    background-color: rgb(190, 240, 155) !important;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.water-used{\n    background-color: lightcyan !important;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.gas-used{\n    background-color: rgb(229, 227, 255) !important;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.alert-value{\n    color: red;\n}\n\n.alert-value-blue{\n    color: blue;\n}\n\n.blank-value{\n    color:rgb(173, 173, 173);\n    padding-right: 10px;\n}\n\n// フッターを下に固定するための修正\n.meter-report-component-all {\n    display: flex;\n    flex-flow: column;\n}\n\n.meter-report-component-main {\n    flex: 1;\n    height: 94vh;\n}\n\n.main-area {\n    height: 100%;\n    overflow-y: auto;\n    background-color: white;\n}\n\n.menu-list{\n    height: 100%;\n}\n\n.no-tenant{\n    color: darkorange;\n}\n\n.footer {\n    width: 100%;\n    position: absolute;/*←絶対位置*/\n    bottom: 0; /*下に固定*/\n}\n\n.mat-mdc-raised-button.mat-confirmed {\n    color: green;\n    background-color: white;\n}\n\n.mat-mdc-raised-button.mat-not-confirmed {\n    color: darkorange;\n    background-color: white;\n}\n\n.meter-name{\n    background-color:whitesmoke;\n}\n\n.meter-type{\n    background-color:whitesmoke;\n    text-align: center;\n}","$main-backgroud: #90CAFC;\n// 本番（PRD）：背景色を薄青（#90CAFC）にする\n// STG：背景色を薄緑（#66cdaa）にする\n// DEV：背景色を黄色（#ffd700）にする\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
